"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const salefilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-salefilled` : '') + (description ? ` desc-salefilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-salefilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-salefilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.31 1.26c.54.06 1.04.3 1.43.68l10.33 10.32.15.18a2.34 2.34 0 0 1-.15 3.13l-6.5 6.5a2.34 2.34 0 0 1-3.3 0L1.92 11.73a2.34 2.34 0 0 1-.68-1.66v-6.5a2.34 2.34 0 0 1 2.34-2.33h6.5l.22.01ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "black"
  }));
};
var _default = exports.default = salefilled;